module.exports = __webpack_public_path__ + "static/poster-fbb3ce939e9346e8b334f4812fdc44a5.png";